import { guardianKeys } from '@/features/guardian/queries/query-keys';
import type { GuardianPlayer } from '@/features/guardian/services/get-guardian-players';
import { removePlayerGuardian } from '@/services/remove-player-guardian';
import { useSessionStore } from '@/stores/session-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * Removes a co-guardian (or leaves the circle when the uid is the caller's own) via
 * DELETE `/api/v1/guardians/me/players/{playerId}/guardians/{guardianUid}`. Invalidates
 * the player's circle and the caller's players list (a left player drops off the list).
 */
export function useRemovePlayerGuardianMutation(playerId: string) {
  const queryClient = useQueryClient();
  const uid = useSessionStore(s => s.user?.uid);
  return useMutation({
    mutationFn: (guardianUid: string) => removePlayerGuardian(playerId, guardianUid),
    onSuccess: () => {
      queryClient.setQueryData<GuardianPlayer[]>(guardianKeys.players(uid), players =>
        players?.filter(player => player.id !== playerId),
      );
      queryClient.invalidateQueries({ queryKey: guardianKeys.players(uid) });
    },
  });
}
